export default "__VITE_PUBLIC_ASSET__702dc1fc__"